module.exports = __webpack_public_path__ + "img/ilhas-pt.279831fc.png";